import { BeautySupplementCategory } from "./v1";

export type BeautySupplementCategoryV1Type = keyof typeof BeautySupplementCategory;
export type BeautySupplementCategoryType = BeautySupplementCategoryV1Type;
